<template>
    <v-card>
      <v-card-title class="headline py-2">
        Редактировать информацию о пользователе
        <v-spacer></v-spacer>
        <v-btn icon class="mx-0" @click="$emit('close-dialog')"><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <v-divider></v-divider>

      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field 
            label="Фамилия" 
            v-model="local_account.last_name" 
            :rules="[v => !!v || 'Необходимо ввести Фамилию']"
            required 
          />
          <v-text-field 
            label="Имя" 
            v-model="local_account.first_name" 
            :rules="[v => !!v || 'Необходимо ввести Имя']"
            required 
          />
          <v-text-field 
            label="Отчество" 
            v-model="local_account.mid_name" 
          />
          <v-select
            :items="genders"
            v-model="local_account.gender"
            label="Пол"
            :rules="[v => !!v || 'Необходимо указать Пол']"
            required
          />
          <v-menu
            lazy
            :close-on-content-click="false"
            v-model="menu"
            transition="scale-transition"
            offset-y
            full-width
            :nudge-right="40"
            max-width="290px"
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              label="Дата рождения"
              v-model="local_account.birthdate"
              append-icon="event"
              readonly
            />
            <v-date-picker
              ref="picker"
              :max="new Date().toISOString().substr(0, 10)"
              v-model="date" 
              @input="menu = false" 
              no-title 
              locale="ru-ru" 
              :first-day-of-week="1"
            />
          </v-menu>

          <div class="text-xs-center">
            <v-btn color="secondary" dark @click="showCrop=!showCrop">
              Загрузить фото 
              <v-icon right dark>cloud_upload</v-icon>
            </v-btn>
          </div>

          <div class="text-xs-center">
            <my-upload 
              field="file"
              @crop-upload-success="cropUploadSuccess"
              @crop-upload-fail="cropUploadFail"
              v-model="showCrop"
              :url="uploadUrl"
              langType="ru"
              :headers="headers"
            />
          </div>

          <div class="text-xs-center">
            <img :src="image_url"
              alt="Фото профиля" 
              style="width:100%; max-width: 300px; border-radius: 50%" 
              class="grey lighten-4 mt-4" 
              v-show="local_account.image"
            />
          </div>
        </v-form>
      </v-card-text>
  
      <v-divider></v-divider>
      <v-card-actions class="pa-3">
        <v-btn color="success" @click="saveAccount" :disabled="!valid || status.btnDisabled">Сохранить</v-btn>
        <span :class="status.className" class="ml-2">{{status.text}}</span>
      </v-card-actions>
      
    </v-card>
</template>

<script>
import myUpload from 'vue-image-crop-upload'
import httpClient from '@/api/http-client'

export default {
  name: 'AccountForm',

  components: {
    'my-upload': myUpload
  },

  props:{
    account:{
      type: Object,
      required: true
    }
  },

  data: () => ({
    uploadUrl: process.env.ACCOUNT_UPLOAD_URL || '/api/private/disk/v1/profile/avatar/',
    date: null,
    menu: false,
    local_account: {},
    genders:[
      { value: 1, text: 'Мужской' },
      { value: 2, text: 'Женский' },
      { value: 3, text: 'Другой' }
    ],
    showCrop: false,
    valid: true,
    status:{
      btnDisabled: false,
      text: '',
      className:'success--text darken-1'
    },
  }),
  
  computed: {
    headers(){
      return {'Authorization': httpClient.config.headers.Authorization }
    },
    image_url(){
      let result = this.local_account.image || ""
      if(this.local_account.image && this.local_account.image.indexOf('base64')<0 && this.local_account.image.indexOf('http')<0){
        result = `/disk/d/preview/resize/500x500/${this.local_account.image}`
      }
      return result
    },
  },
  
  mounted() {
    this.local_account = {...this.account}
    // this.date = this.parseDate(this.local_account.birthdate)
    // TODO: needs to test
    this.date = this.local_account.birthdate
  },

  methods: {
    saveAccount() {
      if (this.$refs.form.validate()) {
        this.status={ btnDisabled: true, text: 'Сохранение', className:'secondary--text lighten-1' }
        this.$store.dispatch('app/account/updateProfile', this.local_account).then(response => {
          this.status={ btnDisabled: false, text: 'Сохранено', className:'success--text darken-1' }
          this.$dmsSuccessNoty('Профиль успешно обновлён')
          this.$emit('save', { type:'profile', data: this.local_account })
        }).catch(error => {
          let errmessage = (error.response) ? error.response.data.error : 'Ошибка'
          this.status={ btnDisabled: false, text: errmessage, className:'error--text darken-1' }
          this.$dmsErrorNoty('Ошибка обновления профиля')
        })
      }
    },

    formatDate(date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },

    parseDate(date) {
      if (!date) {
        return null
      }
      const [day, month, year] = date.split('.')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    cropUploadSuccess(jsonData, field){
      this.local_account.image = jsonData.token;
      
      this.$store.dispatch('app/account/updateProfile', {image: jsonData.token}).then(response => {
        this.$dmsSuccessNoty('Фото успешно обновлено')
      }).catch(error => {
        this.$dmsErrorNoty('Ошибка обновления фото')
      })
    },

    cropUploadFail(status, field){
      console.log('-------- upload fail --------');
      console.log(status);
    }
  },
  
  watch:{
    date(val) {
      // this.local_account.birthdate = this.formatDate(this.date)
      // TODO: needs to test
      this.local_account.birthdate = this.date
    },
    menu (val) {
      val && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'))
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/apps/account/components/Account/Forms/AccountForm.vue